export var TableOverrides = function (theme) { return ({
    MuiTable: {
        root: {
            backgroundColor: theme.palette.background.default,
        },
    },
    MuiTableRow: {
        root: {
            height: 50,
            // MUI component uses this selector to set background color,
            // not {hover: {'&:hover': ...}}
            '&$hover:hover': {
                backgroundColor: theme.palette.background.b3,
            },
            '&:last-child td': {
                borderBottom: 0,
            },
        },
        head: {
            height: 50,
        },
    },
    MuiTableCell: {
        root: {
            fontSize: undefined,
            borderBottom: "1px solid ".concat(theme.palette.background.b4),
            padding: 12,
            boxSizing: 'border-box',
        },
        head: {
            color: theme.palette.text.primary,
            fontWeight: theme.typography.fontWeightSemiBold,
            borderBottom: "2px solid ".concat(theme.palette.background.b4),
            lineHeight: theme.typography.h6.lineHeight,
        },
        body: {
            color: theme.palette.text.primary,
            fontWeight: theme.typography.fontWeightRegular,
        },
    },
    MuiTableSortLabel: {
        root: {
            '&:not($active) $icon': {
                transform: 'none',
            },
        },
        icon: {
            opacity: undefined,
        },
        active: {
            '& $icon': {
                opacity: undefined,
                color: theme.palette.brand.main,
            },
        },
    },
}); };
//# sourceMappingURL=Table.overrides.js.map